<script setup lang="ts">
import CanvasButton from "@/components/canvas/CanvasButton.vue";
import DraggerMenuState from "@/stores/DraggerMenuState";

function toggle() {
  DraggerMenuState.toggleShapeRecognition();
}
</script>
<template>
  <CanvasButton
    @click.prevent.stop="toggle"
    phosphor-icon="shapes"
    :tooltipTitle="$t('canvas:tools.options.shapeRecognition.tooltip.title')"
    :tooltipText="$t('canvas:tools.options.shapeRecognition.tooltip.text')"
    :mode="DraggerMenuState.shapeRecognition"
  />
</template>
